module.exports = __webpack_public_path__ + "img/144.7.834dd37e.png";